import { EnhancedButtonPrimeReact, EnhancedButtonPrimeReactSeverity, LabelPosition, RHookFormNumberFieldWithLabel } from "@websential/cosmic-v20";
import { FC, useEffect, useState } from "react";
import { Toolbar, useTheme } from "@mui/material";
import { provisionalVariableV2InitialData, provisionalVariableV2headerColumns } from "../globalVariablesconstants";

import { Calendar } from "primereact/calendar";
import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import { Dropdown } from "primereact/dropdown";
import { InputNumber } from "primereact/inputnumber";
import { InputText } from "primereact/inputtext";
import { isEqual } from "lodash";

// import "./DataTableUI.css"






let emptyProvisionalVariableV2Status = {
  id: null,
  greaterThanA: null,
  lessThanEqualA: null,
  v2Equal: null,
  lessorOf1: null,
  lessorOf2: null,
};



interface IProvisionalVariableForNonQCSetupV2DataTables {
  provisionalVariableV2Data: (data: any) => void;
  TableDataGetById: any
}
export const ProvisionalVariableForNonQCSetupV2DataTables: FC<IProvisionalVariableForNonQCSetupV2DataTables> = ({
  provisionalVariableV2Data,
  TableDataGetById
}) => {
  const theme = useTheme()
  const [provisionalVariableV2, setProvisionalVariableV2] = useState<any>(provisionalVariableV2InitialData);
  const [selectedProvisionalVariableV2, setSelectedProvisionalVariableV2] = useState<any>(null);
  const [empStatus, setEmpStatus] = useState(emptyProvisionalVariableV2Status);

  // useEffect(() => {
  //   provisionalVariableV2Data(provisionalVariableV2);
  // }, [provisionalVariableV2]);

  useEffect(() => {
    if (!isEqual(provisionalVariableV2, TableDataGetById)) {
      provisionalVariableV2Data([...provisionalVariableV2]);
    }
  }, [provisionalVariableV2]);

  useEffect(() => {
    if (TableDataGetById) {
      setProvisionalVariableV2(TableDataGetById);
    }
    else {
          setProvisionalVariableV2(provisionalVariableV2InitialData)
        }
  }, [TableDataGetById]);

  const findIndexById = (id: string | number | any) => {
    let index = -1;

    for (let i = 0; i < provisionalVariableV2.length; i++) {
      if (provisionalVariableV2[i].id === id) {
        index = i;
        break;
      }
    }

    return index;
  };

  const createId = () => {
    let id = '';
    let chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';

    for (let i = 0; i < 5; i++) {
      id += chars.charAt(Math.floor(Math.random() * chars.length));
    }

    return id;
  };

  const openNew = () => {
    // alert("new")

    let _provisionalVariableV2 = [...provisionalVariableV2];
    let _empStatus: any = { ...empStatus };

    if (empStatus.id) {
      const index = findIndexById(empStatus.id);

      _provisionalVariableV2[index] = _empStatus;
    } else {
      _empStatus.id = createId();
      _provisionalVariableV2.push(_empStatus);
    }



    setProvisionalVariableV2(_provisionalVariableV2);
    setEmpStatus(emptyProvisionalVariableV2Status);
  };
  const resetData = () => {
    setProvisionalVariableV2(provisionalVariableV2InitialData.map((item) => ({ id: item.id, item: null })));
    // setProvisionalVariableV2(
    //   provisionalVariableV2InitialData.map((item:any) => {
    //     const { id } = item;
    //     const resetItem = Object.fromEntries(
    //       Object.keys(item).map((key) => [key, key === "id" ? id : null])
    //     );
    //     return resetItem;
    //   })
    // );


    // setProvisionalVariableV2(provisionalVariableV2InitialData);

  };


  // const confirmDeleteSelected = () => {
  //   let _provisionalVariableV2 = provisionalVariableV2.filter((val:any) => !selectedProvisionalVariableV2.includes(val));
  //   setProvisionalVariableV2(_provisionalVariableV2);
  //   setSelectedProvisionalVariableV2(null);
  // };

  // const onMoveUpClickHandler = () => {
  //   let newData = [...provisionalVariableV2];
  //   const selectedIndices = selectedProvisionalVariableV2.map((item:any) => 
  //     newData.findIndex((dataItem) => dataItem.id === item.id)
  //   );

  //   selectedIndices.forEach((index:any) => {
  //     if (index > 0) {
  //       [newData[index - 1], newData[index]] = [newData[index], newData[index - 1]];
  //     }
  //   });
  //   setProvisionalVariableV2(newData);

  // };
  // const onMoveDownClickHandler = () => {
  //   let newData = [...provisionalVariableV2];
  //   const selectedIndices = selectedProvisionalVariableV2
  //     .map((item:any) => newData.findIndex((dataItem) => dataItem.id === item.id))
  //     .sort((a:any, b:any) => b - a); 

  //   selectedIndices.forEach((index:any) => {
  //     if (index < newData.length - 1) {
  //       [newData[index], newData[index + 1]] = [newData[index + 1], newData[index]];
  //     } 
  //   });
  //   setProvisionalVariableV2(newData);

  // };


  // const onCellValueChange = (event: any, rowIndex: number, field: any) => {

  //   const updatedData = [...provisionalVariableV2];
  // 
  //  
  //   updatedData[rowIndex][event.field] = field;
  //
  //   // setProvisionalVariableV2(updatedData);
  // };

  const onCellValueChange = (event: any, rowIndex: number, field: any) => {
    // setProvisionalVariableV2((prev:any) => {
    //   const updatedData = [...prev];
    //   updatedData[rowIndex][event.field] = field;

    //   return updatedData;
    // });

    setProvisionalVariableV2((prev: any) => {
      const updatedData = [...prev];
      const updatedRow = { ...updatedData[rowIndex], [event.field]: field };
      updatedData[rowIndex] = updatedRow;
      return updatedData;
    });
  };


  // const renderErrorClass = (field: any, rowIndex: number, rowData: any) => {
  //   if (field.field === "date") {
  //     if (rowData.status !== "" && rowData.status !== undefined && rowData.status !== null) {
  //       if(rowData.date === null){
  //         return "p-component p-filled calender-error-input"; 
  //       } else if(rowData.date === ""){
  //         return "p-component p-filled calender-error-input"; 
  //       }
  //     }
  //   } else {
  //     return "p-component p-filled input-dropdown-fields";
  //   }
  // };

  const columnsBody = (rowData: any, row: any, x: any) => {
    // if(x.field === 'notes'){
    //   return (
    //     <InputText
    //         value={rowData[x.field]}
    //         onChange={(e: any) =>
    //           onCellValueChange(x, row.rowIndex, e.target.value)
    //         }
    //         placeholder="Write notes here"
    //         className={renderErrorClass(x, row.rowIndex, rowData)}
    //       />
    //     )
    // }
    return (
      <InputNumber
        // inputId={`yoo-field`}
        value={rowData[x.field]}
        // onValueChange={(e: any) =>
        //             onCellValueChange(x, row.rowIndex, e.target.value)
        //           }
        onValueChange={(e: any) => onCellValueChange(x, row.rowIndex, e.value)}
        placeholder={"0.00"}
        minFractionDigits={2}
        maxFractionDigits={10}
        inputStyle={{
          textAlign: "right",
        }}
      // className={renderErrorClass(x, row.rowIndex, rowData)}
      />
    )
  }


  return (
    <>
      <div className="card" style={{ marginTop: 35 }}>
        <Toolbar sx={{ justifyContent: "end", paddingRight: "0!important" }}>
          <>
            <EnhancedButtonPrimeReact
              label="Add"
              raised
              onClickHandler={openNew}
              style={{ marginLeft: "1rem" }}
              severity={EnhancedButtonPrimeReactSeverity.Secondary}
            />
            <EnhancedButtonPrimeReact
              label="Clear Data"
              raised
              onClickHandler={resetData}
              style={{ marginLeft: "1rem" }}
              severity={EnhancedButtonPrimeReactSeverity.Warning}
            />
          </>
        </Toolbar>
        <DataTable
          value={provisionalVariableV2}
          // selection={selectedProvisionalVariableV2} 
          // onSelectionChange={(e) => setSelectedProvisionalVariableV2(e.value)}
          dataKey="id"
          showGridlines
          className="DataTableUI"
          editMode="cell"
          resizableColumns
          columnResizeMode="expand"
          scrollable
          // reorderableColumns
          filterDisplay="menu"
          // selectionMode="checkbox"
          scrollHeight="516px"
        >
          {/* <Column
                      selectionMode="multiple"
                      // hidden={!showChecboxColumn}
                      frozen={true}
                      resizeable={false}
                      style={{ 
                        width: "36px",
                        textAlign: "center",
                        // zIndex:1,
                        borderRight:"1px solid #e5e7eb",
                        top:0
                       }}
                      field="selection"
                      columnKey="selection"
                      className="selectionHeader"
                      // headerStyle={{zIndex:'2!important'}}
                    /> */}
          {provisionalVariableV2headerColumns.map((x: any, index: any) => {
            return (
              <Column
                key={index}
                field={x.field}
                header={x.headerName}
                headerTooltip={x.description}
                headerTooltipOptions={{ position: "top" }}
                // sortable={false}
                // resizeable={x.resizable}
                // dataType={x.type}
                align={x.align}
                alignHeader={x.headerAlign}
                // reorderable={x.disableReorder}
                // exportable={x.disableExport}
                frozen={x.frozenColumn}
                columnKey={x.field}
                style={{
                  width: x.minWidth,
                  fontSize: "0.875rem",
                }}
                footer={x.footer}
                body={(rowData: any, row: any) => columnsBody(rowData, row, x)}
              />
            );
          })}
        </DataTable>
      </div>
    </>
  );
};
